import { ConfigProviderProps } from 'antd';

import { REQUIRED_FIELD_ERROR_MESSAGE } from '@/constants/texts';

export const getAntdThemeConfig = (
	colorsMap: Record<string, string>,
	isMobile = false,
): ConfigProviderProps => {
	const {
		'brand-primary': brandPrimary,
		'brand-primary-hover': brandPrimaryHover,
		'main-text': mainText,
		error,
	} = colorsMap;

	return {
		form: {
			validateMessages: {
				required: REQUIRED_FIELD_ERROR_MESSAGE,
			},
		},
		theme: {
			token: {
				colorPrimary: brandPrimary,
				colorPrimaryHover: brandPrimaryHover,
				colorPrimaryActive: brandPrimaryHover,
				colorPrimaryBgHover: brandPrimaryHover,
				marginLG: 16,
				colorError: error,
			},
			components: {
				Typography: {
					colorTextHeading: mainText,
					colorText: mainText,
					fontWeightStrong: 600,
				},
				Button: {
					colorPrimary: brandPrimary,
					defaultBorderColor: brandPrimary,
					controlHeight: 38,
					controlHeightLG: 48,
					contentFontSize: 16,
					contentFontSizeLG: 20,
					fontWeight: 500,
					primaryShadow: 'none',
				},
				Input: {
					controlHeight: isMobile ? 44 : 48,
					fontFamily: 'Poppins, sans-serif',
					fontSize: 16,
				},
				DatePicker: {
					controlHeight: isMobile ? 44 : 48,
					fontFamily: 'Poppins, sans-serif',
					fontSize: 16,
				},
				Select: {
					controlHeight: isMobile ? 44 : 48,
					fontFamily: 'Poppins, sans-serif',
					fontSize: 16,
				},
				InputNumber: {
					controlHeight: isMobile ? 44 : 48,
					fontFamily: 'Poppins, sans-serif',
					fontSize: 16,
				},
			},
		},
	};
};
